<script setup lang="ts">
import { EMPTY_IMAGE } from '~/config/empty'

const props = withDefaults(defineProps<{
  /** 空状态文案，兼容 description 写法 */
  text?: string
  description?: string
  imageSize?: number
}>(), {
  text: '暂无数据',
  imageSize: 200,
})

const emptyText = computed(() => props.description || props.text)
</script>

<template>
  <ElEmpty
  style="margin-top: 53px;"
    :image="EMPTY_IMAGE"
    :image-size="props.imageSize"
    :description="emptyText"
  />
</template>
